import React, { useCallback } from 'react';
import { StyledIcon, StyledButton } from './CloseIcon.style';

const CloseIcon = function CloseIcon({
  onClick, onCloseFn, style, classes = '',
}) {
  const handleClick = useCallback(() => {
    onCloseFn?.();
    onClick();
  }, [onClick, onCloseFn]);

  return (
    <StyledButton
      type="button"
      className={`bta-widget-close ${classes}`}
      styled={style.title}
      onClick={handleClick}>
      <StyledIcon />
    </StyledButton>
  );
};

export default CloseIcon;
